import gql from "graphql-tag";

export default gql`
  query($productTypeID: String!) {
    mockups: mockupsByProductType(productTypeID: $productTypeID) {
      id
      title
      preview
      productID
      productType {
        id
        attributes {
          name
          slug
          options
        }
        printAreas {
          id
          width
          height
          name
        }
      }
      # isRender
      ordering
      # isSaveToPB
      width
      height
      layers
      settings {
        defaultBgColor
        changeBgColorByVariantColor
        applyToVariants
      }
    }
  }
`;
